import React from 'react';

const RegSelect = ({ name, label, options, error, ...rest }) => {
  return (
    <div className="form-group">
      <label
        style={{
          display: 'block',
          color: 'black',
          fontWeight: 'bold',
          fontSize: 12 + 'px'
        }}
        htmlFor={name}
      >
        {label}
      </label>
      <select
        name={name}
        id={name}
        {...rest}
        className="form-control"
        style={{ borderRadius: 0 }}
      >
        <option value="" />
        {options.map(option => (
          <option key={option._id} value={option._id}>
            {option.name}
          </option>
        ))}
      </select>
      {error && <div className="alert alert-danger">{error}</div>}
    </div>
  );
};

export default RegSelect;
